export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/bulksmasher.worker.66522364.worker.js");
}
